"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SendParentInviteBadRequest extends client_library_1.ExtendableError {
    constructor(reason) {
        super(`Could not send invite to parent: ${reason}`);
    }
}
exports.default = SendParentInviteBadRequest;
//# sourceMappingURL=SendParentInviteBadRequest.js.map